import { useUserAuth } from '@/state/cookieContext';

/**
 * 사용자 상태 관리 훅
 *
 * 현재 로그인된 사용자의 인증 정보와 상태를 반환합니다.
 * - 사용자 ID, 액세스 토큰, 리프레시 토큰
 * - 사용자 권한 정보
 * - 토큰 디코드 정보
 *
 * @returns 사용자 인증 상태와 정보
 */
export default function useUserState() {
  return useUserAuth();
}
